import React, { useState } from 'react';
import { Skeleton } from '@mui/material';

/**
 * Image with a shimmer placeholder shown until the image finishes loading.
 * Falls back gracefully on error (caller can pass onError to swap src).
 */
const ImageWithShimmer = ({ src, alt = '', className = '', imgClassName = '', onError, ...rest }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <div className={`relative overflow-hidden ${className}`}>
            {!loaded && (
                <Skeleton
                    variant="rectangular"
                    animation="wave"
                    sx={{ position: 'absolute', inset: 0, width: '100%', height: '100%', borderRadius: 'inherit' }}
                />
            )}
            <img
                src={src}
                alt={alt}
                onLoad={() => setLoaded(true)}
                onError={(e) => { setLoaded(true); if (onError) onError(e); }}
                className={`w-full h-full object-cover transition-opacity duration-300 ${loaded ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
                {...rest}
            />
        </div>
    );
};

export default ImageWithShimmer;
